// src/pages/PagesUtilisateurs/DashboardUsers/hooks/useDashboardUser.js

import { useEffect, useMemo, useState } from "react";

import { useUser } from "../../../Home/UserContext";
import { getRoleFromRoleId } from "../../../../utils/roleHelper";

const getStoredUserId = () => {
  try {
    const raw = localStorage.getItem("userInfo");

    if (!raw) return null;

    const parsed = JSON.parse(raw);

    return parsed?.userId || parsed?.id || null;
  } catch {
    return null;
  }
};

export default function useDashboardUser() {
  const { user } = useUser();

  const userId = useMemo(() => {
    return (
      user?.userId ||
      user?.id ||
      getStoredUserId()
    );
  }, [user]);

  const role = useMemo(
    () => getRoleFromRoleId(user?.role_id),
    [user?.role_id],
  );

  const isAdminOrTeacher =
    role === "admin" ||
    role === "administrateur" ||
    role === "enseignant";

  const [activeModule, setActiveModule] = useState(() => {
    return (
      localStorage.getItem("dash_user_active_tab") ||
      "notifications"
    );
  });

  useEffect(() => {
    if (!activeModule) return;

    localStorage.setItem(
      "dash_user_active_tab",
      activeModule,
    );
  }, [activeModule]);

  return {
    user,
    userId,
    role,
    isAdminOrTeacher,

    activeModule,
    setActiveModule,
  };
}